import apiClient from "./apiClient";
import { DeleteRequest } from "@/types/deleteRequest";
import {
  KindergartenAllowanceItem,
  KindergartenDocumentInfo, KindergartenSearchParams,
  LmsSystemItem
} from "@/types/kindergarten";
import { PageResponse } from "@/types/pageResponse";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const BASE_URL_KINDERGARTEN = `${BASE_URL}/api/v1/kindergarten`;
const KINDERGARTEN_DOCUMENT_LIST_URL = `${BASE_URL_KINDERGARTEN}/document/info/list/search`;
const KINDERGARTEN_DOCUMENT_INFO_BY_ID = `${BASE_URL_KINDERGARTEN}/document/info/`;
const LMS_LIST_URL = `${BASE_URL_KINDERGARTEN}/lms`;
const SAVE_UPDATE_DELETE_KINDERGARTEN_DOCUMENT_INFO_URL = `${BASE_URL_KINDERGARTEN}/document`;
const SAVE_UPDATE_DELETE_LMS_SYSTEMS_URL = `${BASE_URL_KINDERGARTEN}/lms`;
const SAVE_UPDATE_DELETE_KINDERGARTEN_ALLOWANCE_URL = `${BASE_URL_KINDERGARTEN}/allowance`;

export async function getKindergartenDocumentInfo(
  params: KindergartenSearchParams
): Promise<PageResponse<KindergartenDocumentInfo>> {
  try {
    const response = await apiClient.post<PageResponse<KindergartenDocumentInfo>>(
      KINDERGARTEN_DOCUMENT_LIST_URL, params
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching directory list:", error);
    throw error;
  }
}

export async function getLmsSystems(
  token: string
): Promise<LmsSystemItem[]> {
  try {
    const response = await apiClient.get<LmsSystemItem[]>(
      LMS_LIST_URL,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching directory list:", error);
    throw error;
  }
}

export async function getKindergartenDocumentInfoById(
    token: string,
    kindergartenDocumentInfoId: string
): Promise<KindergartenDocumentInfo> {
  try {
    const response = await apiClient.get<KindergartenDocumentInfo>(
        `${KINDERGARTEN_DOCUMENT_INFO_BY_ID}${kindergartenDocumentInfoId}`,
        {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching directory list:", error);
    throw error;
  }
}

export async function createKindergartenDocumentInfo(
    kindergartenDocumentInfo: KindergartenDocumentInfo
): Promise<KindergartenDocumentInfo> {
  try {
    const response = await apiClient.post<KindergartenDocumentInfo>(
        SAVE_UPDATE_DELETE_KINDERGARTEN_DOCUMENT_INFO_URL,
        kindergartenDocumentInfo
    );
    return response.data;
  } catch (error) {
    console.error("Error saving kindergartenDocumentInfo:", error);
    throw error;
  }
}

export async function updateKindergartenDocumentInfo(
    kindergartenDocumentInfo: KindergartenDocumentInfo
): Promise<KindergartenDocumentInfo> {
  try {
    const response = await apiClient.put<KindergartenDocumentInfo>(
        SAVE_UPDATE_DELETE_KINDERGARTEN_DOCUMENT_INFO_URL,
        kindergartenDocumentInfo
    );
    return response.data;
  } catch (error) {
    console.error("Error updating kindergartenDocumentInfo:", error);
    throw error;
  }
}

export async function deleteKindergartenDocumentInfo(
    id: number,
    reason: string
) {
  try {
    const response = await apiClient.post(
        `${SAVE_UPDATE_DELETE_KINDERGARTEN_DOCUMENT_INFO_URL}/delete`,
        { ids: [id], reason } as DeleteRequest<number>
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting kindergartenDocumentInfo:", error);
    throw error;
  }
}

export async function createLmsSystem(
    lmsSystem: LmsSystemItem
):Promise<LmsSystemItem> {
  try {
    const response = await apiClient.post<LmsSystemItem>(
        SAVE_UPDATE_DELETE_LMS_SYSTEMS_URL, lmsSystem
    );
    return response.data;
  } catch (error) {
    console.error("Error creating LmsSystem:", error);
    throw error;
  }
}

export async function updateLmsSystem(
    lmsSystem: LmsSystemItem
):Promise<LmsSystemItem> {
  try {
    const response = await apiClient.put<LmsSystemItem>(
        SAVE_UPDATE_DELETE_LMS_SYSTEMS_URL, lmsSystem
    );
    return response.data;
  } catch (error) {
    console.error("Error updating LmsSystem:", error);
    throw error;
  }
}

export async function deleteLmsSystem(
    id: number,
    reason: string
) {
  try {
    const response = await apiClient.post(
        `${SAVE_UPDATE_DELETE_LMS_SYSTEMS_URL}/delete`,
        { ids: [id], reason } as DeleteRequest<number>
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting LmsSystem:", error);
    throw error;
  }
}

export async function createKindergartenAllowance(
    kindergartenAllowance: KindergartenAllowanceItem
): Promise<KindergartenAllowanceItem> {
  try {
    const response = await apiClient.post<KindergartenAllowanceItem>(
        SAVE_UPDATE_DELETE_KINDERGARTEN_ALLOWANCE_URL, kindergartenAllowance
    );
    return response.data;
  } catch (error) {
    console.error("Error creating KindergartenAllowance:", error);
    throw error;
  }
}

export async function updateKindergartenAllowance(
    kindergartenAllowance: KindergartenAllowanceItem
): Promise<KindergartenAllowanceItem> {
  try {
    const response = await apiClient.put<KindergartenAllowanceItem>(
        SAVE_UPDATE_DELETE_KINDERGARTEN_ALLOWANCE_URL, kindergartenAllowance
    );
    return response.data;
  } catch (error) {
    console.error("Error updating KindergartenAllowance:", error);
    throw error;
  }
}

export async function deleteKindergartenAllowance(
    id: number,
    reason: string
) {
  try {
    const response = await apiClient.post(
        `${SAVE_UPDATE_DELETE_KINDERGARTEN_ALLOWANCE_URL}/delete`,
        { ids: [id], reason } as DeleteRequest<number>
    );
    return response.data;
  } catch(error) {
    console.error("Error deleting KindergartenAllowance:", error);
    throw error;
  }
}